// ReachUsButton.js
import React, { useState, useEffect } from 'react';
import './ReachUsButton.css';
import { Link } from 'react-router-dom';

const ReachUsButton = () => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  

  return (
    <Link to="/contact">
  <button className="reach-us-btn" style={{ top: windowHeight / 2  }}>
  <strong>Reach Us</strong>
  </button>
</Link>
  );
};

export default ReachUsButton;
